function debounce(fn, delay) {
  let timeoutID = null
  return (params) => {
    clearTimeout(timeoutID)
    timeoutID = setTimeout(() => {
      fn(params)
    }, delay)
  }
}

export default debounce
